var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class PatternsApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'patterns';
    }
    getPatterns(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}`,
                params: params,
            });
        });
    }
    getPatternsV2(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `v2/${this.apiBasePath}`,
                params: params,
            });
        });
    }
    createPattern(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}`,
                data,
            });
        });
    }
    updatePatternByContractId(contractId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PATCH',
                route: `${this.apiBasePath}`,
                params: { contractId },
                data,
            });
        });
    }
    deletePattern(id_1) {
        return __awaiter(this, arguments, void 0, function* (id, softDelete = true) {
            return yield this.apiCall({
                method: 'DELETE',
                route: `${this.apiBasePath}`,
                params: {
                    id: id,
                    softDelete: softDelete,
                },
            });
        });
    }
}
//# sourceMappingURL=index.js.map